(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    // Ask for the sections by their DYNAMIC ids, read off the elements.
    //
    // Sections that live in a section group are addressed as
    // `sections--22393429917731__cart-drawer`, not `cart-drawer`. Requesting the
    // bare name still returns 200 with markup — it just renders the section file
    // with SCHEMA DEFAULTS, silently dropping every group setting and block. In
    // this drawer that meant the dog-gear size-confirmation line vanished the
    // moment a quantity changed; in the footer it emptied three of five columns.
    // Verified against the dev server both ways.
    //
    // `[data-cart-page]` joins the list on the cart page, so a quantity change
    // there updates the page, the header chip and the drawer in one request
    // instead of reloading. The Ajax API allows five sections per call; this is
    // at most three.
    function targets() {
      const list = [];
      document
        .querySelectorAll('[data-cart-drawer], [data-header], [data-cart-page]')
        .forEach((el) => {
          if (el.dataset.sectionId) list.push({ el, id: el.dataset.sectionId });
        });
      return list;
    }

    function open() {
      if (!drawer.open) drawer.showModal();
    }

    function refresh(sections, requested) {
      requested.forEach(({ el, id }) => {
        const markup = sections[id];
        if (!markup) return;

        const parsed = new DOMParser().parseFromString(markup, 'text/html');

        // The drawer swaps only its panel, so the <dialog> stays open and keeps
        // its top-layer state. Everything else swaps whole, matched on its own
        // marker attribute rather than a hardcoded one.
        if (el.hasAttribute('data-cart-drawer')) {
          const next = parsed.querySelector('.cart-drawer__panel');
          const current = el.querySelector('.cart-drawer__panel');
          if (next && current) current.replaceWith(next);
          return;
        }

        const marker = el.hasAttribute('data-cart-page') ? '[data-cart-page]' : '[data-header]';
        const next = parsed.querySelector(marker);
        if (next) el.replaceWith(next);
      });

      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    // THE one mutation function. Quantity changes and adds both come through
    // here, so there is one request shape, one guarded parse and one failure
    // shape: `cart:error` with `{ form | null, source: 'add' | 'quantity',
    // message }`. The listeners below route on it — an add's error into its
    // own form's `[data-cart-error="form"]`, a quantity error into the page's
    // `[data-cart-error="page"]` — and render it AMBER. Red means go in this
    // system; an error wearing it makes both meanings useless.
    //
    // A quantity change can fail for a reason the customer needs to hear —
    // "Only 1 item was added to your cart due to availability" is a real 422
    // from this store's own stock. A non-JSON 5xx is caught by the guarded
    // parse and still reaches the listener rather than rejecting unhandled.
    async function mutate(url, init, { form = null, source }) {
      const requested = targets();
      const ids = requested.map((t) => t.id).join(',');
      let body = init.body;
      if (body instanceof FormData) {
        body.delete('sections');
        body.append('sections', ids);
      } else {
        body = JSON.stringify(Object.assign({ sections: ids }, body));
      }

      const response = await fetch(url, { method: 'POST', headers: init.headers, body });

      let data = {};
      try {
        data = await response.json();
      } catch (error) {
        data = {};
      }

      if (!response.ok) {
        document.dispatchEvent(
          new CustomEvent('cart:error', {
            detail: {
              form: form || null,
              source,
              message: data.description || data.message || (form && form.dataset.errorFallback) || '',
            },
          })
        );
        return { ok: false, data };
      }

      // Every add in the theme funnels through here — the PDP, the sticky bar,
      // "complete the setup", the kit page and both finders. One event at the choke point instruments all of them,
      // and it cannot fire on a rejected add because that returned above.
      if (form) document.dispatchEvent(new CustomEvent('cart:added', { detail: { form, data } }));

      if (data.sections) refresh(data.sections, requested);
      return { ok: true, data };
    }

    function post(url, body) {
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      return mutate(url, { headers, body }, { source: 'quantity' });
    }

    // Adds submit as FORM DATA rather than JSON, because a real product form
    // carries more than an id: a quantity, line-item properties, a selling plan,
    // and — in the "complete the setup" block — several items[] at once. Serialising
    // that by hand is how a sticky bar ends up adding the wrong variant. The form
    // is the single source of truth for what is being added.
    function postForm(form) {
      const url = window.Shopify.routes.root + 'cart/add.js';
      return mutate(url, { headers: { Accept: 'application/json' }, body: new FormData(form) }, { form, source: 'add' });
    }

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        open();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        drawer.close();
        return;
      }

      const step = event.target.closest('[data-quantity-change]');
      if (step) {
        const line = step.closest('[data-line-key]');
        if (!line) return;
        event.preventDefault();
        post(window.Shopify.routes.root + 'cart/change.js', {
          id: line.dataset.lineKey,
          quantity: Number(step.dataset.quantityChange),
        });
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-cart-add]');
      if (!form) return;
      event.preventDefault();

      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      postForm(form)
        .then((result) => {
          // On the cart page the customer is already looking at the cart;
          // sliding a drawer over it hides what they just changed.
          if (result.ok && !document.querySelector('[data-cart-page]')) open();
        })
        .finally(() => {
          if (button) button.disabled = false;
        });
    });

    // Both error surfaces are owned here, beside the request that fails, and
    // both show the server's own words in AMBER. An add's error goes into ITS
    // form's `[data-cart-error="form"]` — every `data-cart-add` form renders one,
    // hidden — so a rejected add on the PDP, "complete the setup", a finder card
    // or the cross-sell is never silent. A quantity error goes
    // into `[data-cart-error="page"]`: the drawer's and the cart page's, never a
    // form's. A later successful change hides them all, which is the right
    // lifetime for the message.
    function showError(region, message) {
      if (!region) return;
      const content = region.querySelector('.alert__content');
      if (content) content.textContent = message;
      region.hidden = !message;
    }

    document.addEventListener('cart:error', (event) => {
      const detail = event.detail || {};
      if (detail.source === 'add') {
        showError(detail.form && detail.form.querySelector('[data-cart-error="form"]'), detail.message);
        return;
      }
      document
        .querySelectorAll('[data-cart-error="page"]')
        .forEach((region) => showError(region, detail.message));
    });

    document.addEventListener('cart:updated', () => {
      document.querySelectorAll('[data-cart-error]').forEach((region) => {
        region.hidden = true;
      });
    });

    // Clicking the backdrop closes the drawer. <dialog> already handles Escape.
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-finder"] && !Shopify.designMode) return;
  try {
    
  // The sizer. Three paths, and it says which one it took.
  //
  // Path A reads the product's OWN chart, live. Path B reads the one verified
  // reference chart in `data-finder-config`, matching only on the two
  // inputs both ladders define identically — back length and weight. Path C
  // computes nothing, because inventing a harness size is how a dog ends up in
  // a harness that does not fit.
  //
  // Every computed size is intersected against the ladder the product actually
  // sells before it is shown. That intersection is the whole reason this file
  // does not simply read a chart and print a letter.
  (function () {
    var ORDER = ['mini', 'xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', 'exl'];
    var CM_RANGE = /(\d+(?:[.,]\d+)?)\s*(?:[–—-]\s*(\d+(?:[.,]\d+)?))?\s*cm/i;

    // Within this many centimetres of a size boundary, the confidence line
    // shows rather than a bare answer (the manufacturer's fitting guidance).
    var BOUNDARY_CM = 1;

    function num(value) {
      var parsed = parseFloat(String(value).replace(',', '.'));
      return isNaN(parsed) ? null : parsed;
    }

    function rung(size) {
      return ORDER.indexOf(String(size).trim().toLowerCase());
    }

    // A chart row counts only when the product sells that size AND the row is a
    // collar measurement in centimetres. `bag-for-equipment` uses the same field
    // for `Height 70 cm`, and `boots-comfort` for `Width 55 mm` — neither is a
    // harness ladder, and neither may be read as one.
    function collarRows(product) {
      var sold = product.sizes.map(function (s) { return s.trim().toLowerCase(); });
      return (product.chart || [])
        .filter(function (row) {
          if (sold.indexOf(String(row.size).trim().toLowerCase()) === -1) return false;
          return /collar/i.test(row.text) && CM_RANGE.test(row.text);
        })
        .map(function (row) {
          var match = row.text.match(CM_RANGE);
          var min = num(match[1]);
          var max = match[2] ? num(match[2]) : min;
          return { size: row.size, text: row.text, min: min, max: max };
        })
        .sort(function (a, b) { return a.min - b.min; });
    }

    function distance(value, row) {
      if (value < row.min) return row.min - value;
      if (value > row.max) return value - row.max;
      return 0;
    }

    // A kit is sized from the chart of the harness inside it, so the
    // reference-chart lookup keys on whichever product the chart came from.
    function referenceChart(product, reference) {
      var charts = (reference && reference.charts) || {};
      return charts[product.chart_handle || product.handle] || null;
    }

    function path(product, reference) {
      if (collarRows(product).length) return 'A';
      if (referenceChart(product, reference)) return 'B';
      return 'C';
    }

    // The owner's tree, leaf by leaf. Every id here has a `result_<id>` list and
    // a `why_<id>` sentence in the schema. Each branch reads only the answers on
    // its own path, so an answer left over from a branch the customer backed out
    // of is never consulted.
    var BREED_OUTCOME = { nordic: 'mushing_nordic', pointer: 'mushing_pointer', mixed: 'mixed' };
    var SPORT_PREFIX = { canicross: 'cc', bikejoring: 'bj' };

    function route(a) {
      var build = { small: 'small', large: 'large' }[a.build];
      if (!build) return null;
      if (a.sport === 'walking') return 'walk_' + build;

      var prefix = SPORT_PREFIX[a.sport];
      if (!prefix) return null;
      if (a.level === 'beginner') return prefix + '_beginner_' + build;
      if (a.level !== 'experienced') return null;
      if (build === 'small') return prefix + '_experienced_small';
      return BREED_OUTCOME[a.breed] ? prefix + '_' + BREED_OUTCOME[a.breed] : null;
    }

    // Candidates in the owner's order of preference. A listed handle with no
    // entry was skipped by the pool (sold out, or no size option to compute).
    // Inline, the catalogue is the page's own product and nothing else.
    function candidates(catalogue, config, outcomeId) {
      if (config.inline) return catalogue;
      var outcome = outcomeId && config.outcomes ? config.outcomes[outcomeId] : null;
      if (!outcome) return [];
      return (outcome.handles || [])
        .map(function (handle) {
          return catalogue.filter(function (product) { return product.handle === handle; })[0];
        })
        .filter(Boolean);
    }

    function soldRung(product, index) {
      var sold = product.sizes
        .map(function (size) { return { size: size, rung: rung(size) }; })
        .filter(function (entry) { return entry.rung !== -1; })
        .sort(function (a, b) { return a.rung - b.rung; });
      if (!sold.length) return null;

      var exact = sold.filter(function (entry) { return entry.rung === index; })[0];
      if (exact) return { size: exact.size, exact: true };

      var nearest = sold.reduce(function (best, entry) {
        return Math.abs(entry.rung - index) < Math.abs(best.rung - index) ? entry : best;
      }, sold[0]);
      return { size: nearest.size, exact: false };
    }

    function purchasable(product, size) {
      if (!size) return false;
      var list = product.available_sizes || product.sizes;
      return list.some(function (value) {
        return String(value).trim().toLowerCase() === String(size).trim().toLowerCase();
      });
    }

    // True when every question a path sizes from is switched off in the theme
    // editor: path A reads the collar, path B back length or weight.
    function unasked(taken, reference) {
      var ask = (reference && reference.ask) || {};
      if (taken === 'A') return ask.neck === false;
      if (taken === 'B') return ask.weight === false && ask.back === false;
      return false;
    }

    // Everything the result screen needs about ONE candidate: which path was
    // taken, the size it produced, and every caution that produced it.
    function measure(product, answers, reference, strings) {
      var notes = [];
      var taken = path(product, reference);
      var computed = null;

      if (taken === 'A') computed = sizeFromCollar(product, answers, strings, notes);
      if (taken === 'B') computed = sizeFromReference(product, answers, reference, strings, notes);

      var size = '';
      if (computed) {
        var index = rung(computed.size);

        // The fitting rule the manufacturer publishes: a deep-chested or
        // barrel-chested dog goes up, not across.
        if (answers.shape === 'deep' && index !== -1) {
          var up = soldRung(product, index + 1);
          if (up && up.exact) {
            notes.push(strings.deep_chested);
            index += 1;
          }
        }

        var resolved = soldRung(product, index);
        if (resolved) {
          size = resolved.size;
          if (!resolved.exact) notes.push(strings.not_sold);
        }
      } else if (unasked(taken, reference)) {
        // The chart is readable, but the questions it is read with are
        // switched off, so the customer reads it, not the finder.
        notes.push(String(strings.unsized).replace('{ladder}', product.sizes.join(' · ')));
      } else {
        notes.push(String(strings.no_chart).replace('{ladder}', product.sizes.join(' · ')));
      }

      return {
        product: product,
        taken: taken,
        computed: computed,
        size: size,
        notes: notes,
        purchasable: purchasable(product, size),
      };
    }

    // Recommend a harness whose computed size can actually be bought. The
    // owner's first choice is worthless if the rung it produces is sold out —
    // `harness-soft-universal` sells nine sizes and has four in stock — so the
    // rest of the list are backups, in order. Only when nothing can be bought
    // does the first one come back, and then the sold-out alert on its own card
    // is the honest answer.
    function choose(ranked, answers, reference, strings) {
      var fallback = null;

      for (var i = 0; i < ranked.length; i += 1) {
        var result = measure(ranked[i], answers, reference, strings);
        if (!fallback) fallback = result;
        if (result.size && result.purchasable) return result;
        // Its sizing questions not asked: this harness can never produce a
        // size, and skipping it would hand the owner's first choice to whatever
        // later harness can be sized. It stands, unsized, while any of its
        // sizes is in stock.
        if (unasked(result.taken, reference)
          && (ranked[i].available_sizes || ranked[i].sizes).length) return result;
      }
      return fallback;
    }

    function sizeFromCollar(product, answers, strings, notes) {
      var rows = collarRows(product);
      var neck = num(answers.neck);
      if (!neck) return null;

      var row = rows.filter(function (r) { return neck >= r.min && neck <= r.max; })[0];
      if (!row) {
        // Nearest row by distance, not "the last one". `harness-merhi` publishes
        // single points — 44, 48, 52 — so a 50 cm collar falls between two rows
        // rather than outside the chart, and taking the last row would have sent
        // every in-between dog to the biggest size on offer. A tie rounds UP,
        // which is the manufacturer's own rule for a dog between two sizes.
        row = rows.reduce(function (best, candidate) {
          return distance(neck, candidate) <= distance(neck, best) ? candidate : best;
        }, rows[0]);
        notes.push(strings.boundary);
      } else if (neck - row.min <= BOUNDARY_CM || row.max - neck <= BOUNDARY_CM) {
        notes.push(strings.boundary);
      }
      return { size: row.size, range: row.text };
    }

    function sizeFromReference(product, answers, reference, strings, notes) {
      var chart = referenceChart(product, reference);
      var back = num(answers.back);
      var weight = num(answers.dog_weight);

      var row = null;
      if (back) {
        row = chart.sizes.filter(function (r) {
          return back >= r.back_min && back <= r.back_max;
        })[0];
      }
      if (!row && weight) {
        row = chart.sizes.filter(function (r) {
          return weight >= r.weight_min && weight <= r.weight_max;
        })[0];
      }
      if (!row) return null;

      // Path B never checked the neck, because this chart's neck ladder and the
      // store's collar ladder are different measurements. Say so.
      notes.push(
        String(strings.confirm_neck)
          .replace('{min}', row.neck_min)
          .replace('{max}', row.neck_max)
      );

      if (back && (back - row.back_min <= BOUNDARY_CM || row.back_max - back <= BOUNDARY_CM)) {
        notes.push(strings.boundary);
      }
      return {
        size: row.size,
        range: row.back_min + '–' + row.back_max + ' cm back · ' + row.weight_min + '–' + row.weight_max + ' kg',
      };
    }

    function readJSON(root, selector) {
      var node = root.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    // The catalogue is every eligible harness's entry, in render order — the
    // order `rankCandidates()` breaks exact ties in. Each entry sits beside its
    // card.
    function readCatalogue(root) {
      var list = [];
      root.querySelectorAll('[data-finder-entry]').forEach(function (node) {
        try {
          list.push(JSON.parse(node.textContent));
        } catch (error) {
          // One malformed entry drops one candidate, never the finder.
        }
      });
      return list;
    }

    function remember(root, answers, product, size) {
      var save = root.querySelector('[data-finder-save]');
      if (save && !save.checked) return;
      try {
        window.localStorage.setItem(
          'footbikes:dog_profile',
          JSON.stringify({
            sport: answers.sport || '',
            level: answers.level || '',
            build: answers.build || '',
            breed: answers.breed || '',
            weight: num(answers.dog_weight),
            neck: num(answers.neck),
            back: num(answers.back),
            shape: answers.shape || '',
            handle: product ? product.handle : '',
            size: size || '',
          })
        );
      } catch (error) {
        // Storage can be blocked outright, and the result is on screen anyway.
      }
    }

    function setup(root) {
      var config = readJSON(root, '[data-finder-config]');
      var catalogue = readCatalogue(root);
      if (!config) return;

      var strings = config.strings || {};

      root.addEventListener('finder:complete', function (event) {
        var answers = event.detail.answers;
        var heading = root.querySelector('[data-finder-result-heading]');
        var label = root.querySelector('[data-finder-size-label]');
        var range = root.querySelector('[data-finder-size-range]');
        var confidence = root.querySelector('[data-finder-confidence]');
        var nomatch = root.querySelector('[data-finder-nomatch]');
        var slot = root.querySelector('[data-finder-primary]');
        var pool = root.querySelector('[data-finder-pool]');

        // A restart or a second completion starts from a clean result. The
        // card placed last time goes back to the pool — `place()` empties the
        // slot, which would otherwise delete it from the page — and nothing
        // from the previous answer survives into this one.
        if (slot && pool) {
          slot.querySelectorAll('[data-finder-card]').forEach(function (node) {
            node.hidden = true;
            pool.appendChild(node);
          });
        }
        if (nomatch) nomatch.hidden = true;
        if (label) label.hidden = true;
        if (range) range.hidden = true;
        if (confidence) confidence.hidden = true;

        // Synchronous: the reference data is already on the page, so the result
        // is filled before the shell reveals it (finder-step).
        var outcomeId = config.inline ? null : route(answers);
        var ranked = candidates(catalogue, config, outcomeId);
        var outcome = choose(ranked, answers, config, strings);
        if (!outcome) {
          // An outcome the owner has not filled yet, or whose harnesses are all
          // sold out: the no-match panel and a human, never a guess.
          if (nomatch) nomatch.hidden = false;
          if (heading) heading.textContent = strings.no_size;
          concierge(null, '');
          return;
        }

        var product = outcome.product;
        var computed = outcome.computed;
        var notes = outcome.notes;
        var finalSize = outcome.size;

        if (heading) {
          heading.textContent = finalSize
            ? String(strings.size_label).replace('{size}', finalSize)
            : strings.no_size;
        }
        if (label) {
          label.textContent = product.title;
          label.hidden = false;
        }
        if (range && computed && computed.range) {
          range.textContent = computed.range;
          range.hidden = false;
        }

        if (confidence) {
          if (notes.length) {
            var body = confidence.querySelector('.alert__content');
            if (body) body.textContent = notes.join(' ');
            confidence.hidden = false;
          } else {
            confidence.hidden = true;
          }
        }

        // Placement belongs to the card (`window.FinderCard`); the size, the
        // owner's "why" and the pre-selected chip are the sizer's.
        var cards = window.FinderCard;
        var card = cards ? cards.find(root, product.handle) : null;
        if (card && slot) {
          cards.place(slot, card, strings.role_primary);

          // Why this harness, in the owner's words (`why_<outcome>`). The size
          // answers "which size"; this answers "why this harness for my dog",
          // which is the question the tree decided. Blank ⇒ no line. Inline
          // the customer chose the product, so there is nothing to explain.
          var whyEl = card.querySelector('[data-finder-why]');
          var why = outcomeId && config.outcomes[outcomeId] ? config.outcomes[outcomeId].why : '';
          if (whyEl) {
            whyEl.textContent = '';
            if (why) {
              var line = document.createElement('p');
              line.textContent = why;
              whyEl.appendChild(line);
            }
            whyEl.hidden = !why;
          }

          if (finalSize) {
            var chips = card.querySelectorAll('[data-finder-size]');
            chips.forEach(function (chip) {
              if (chip.value === finalSize) chip.checked = true;
            });
          }
          cards.resolve(card);
        }

        remember(root, answers, product, finalSize);
        concierge(product, finalSize);

        // The concierge email carries the answers, so a human can pick up
        // where the finder stopped — including when it found nothing. Only the
        // answers given are listed: weight, back length and build can be
        // switched off in the editor, and back length is optional anyway.
        function concierge(chosen, size) {
          var link = root.querySelector('[data-finder-concierge]');
          if (!link || !config.email) return;
          var parts = strings.concierge_dog || {};
          var dog = ['dog_weight', 'neck', 'back', 'shape']
            .filter(function (name) { return answers[name] && parts[name]; })
            .map(function (name) { return String(parts[name]).replace('{value}', answers[name]); })
            .join(', ');
          var text = String(strings.concierge_body || '')
            .replace('{dog}', dog || '—')
            .replace('{title}', chosen ? chosen.title : '—')
            .replace('{size}', size || '—');
          link.setAttribute('href', window.Finder.mailto(config.email, config.subject, text));
        }
      });
    }

    document.querySelectorAll('[data-finder="fit"]').forEach(setup);

    // The PDP's red "Find my dog's size" is an anchor to the inline panel. A
    // fragment does not reliably open a closed <details>, so open it here and
    // move focus into it — otherwise the button looks broken on the one page
    // where sizing anxiety is the conversion blocker.
    function openPanel(hash) {
      if (!hash) return;
      var panel = document.querySelector('[data-fit-panel]' + hash);
      if (!panel) return;
      panel.open = true;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (hash.length < 2) return;
      if (!document.querySelector('[data-fit-panel]' + hash)) return;
      event.preventDefault();
      openPanel(hash);
    });

    openPanel(window.location.hash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footbike-finder"] && !Shopify.designMode) return;
  try {
    
  // The router. `route()` reads the answers on the customer's branch and names
  // one outcome; the outcome's models are whatever the merchant picked for it,
  // already filtered to what is in stock. Nothing here knows a product.
  (function () {
    var KID_OUTCOME = { h110_140: 'kid_small', h140_160: 'kid_mid', o160: 'kid_tall' };

    // Returns the outcome id and the steps on the branch that reached it, or
    // null for an answer set the tree does not cover. Only the branch's own
    // answers are read, so an answer left over from a branch the customer
    // backed out of cannot change the result.
    function route(a) {
      if (a.who === 'dog') {
        var dogOutcome = {
          entry: a.dogs === 'd2' ? 'dog_entry_2' : 'dog_entry_1',
          mid: a.solo === 'yes' ? 'dog_mid_solo' : 'dog_mid_mushing',
          top: 'dog_top',
        }[a.dog_budget];
        return dogOutcome ? { id: dogOutcome, steps: ['who', 'solo', 'dogs', 'dog_budget'] } : null;
      }
      if (a.who === 'adult') {
        if (a.fold === 'yes') return { id: 'adult_fold', steps: ['who', 'fold'] };
        var adultOutcome = { entry: 'adult_entry', best: 'adult_best' }[a.adult_budget];
        return adultOutcome ? { id: adultOutcome, steps: ['who', 'fold', 'adult_budget'] } : null;
      }
      if (a.who === 'kid') {
        var kidOutcome = KID_OUTCOME[a.kid_height];
        return kidOutcome ? { id: kidOutcome, steps: ['who', 'kid_height'] } : null;
      }
      return null;
    }

    function readJSON(root, selector) {
      var node = root.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    // A restart or a second completion puts every placed card and kit tile back
    // in the pool, so the next result can place them again. Clearing the slots
    // instead would delete them from the page.
    function reclaim(root) {
      var pool = root.querySelector('[data-finder-pool]');
      var results = root.querySelector('[data-finder-results]');
      var kit = root.querySelector('[data-finder-kit]');
      if (!pool) return;

      root.querySelectorAll('[data-finder-results] [data-finder-card], [data-finder-kit] [data-finder-kit-for]').forEach(function (node) {
        if (node.matches('[data-finder-card]')) node.hidden = true;
        pool.appendChild(node);
      });
      if (results) results.textContent = '';
      if (kit) kit.hidden = true;
    }

    // Placement belongs to the card (`window.FinderCard`). The heading already
    // says "your match", so the per-card role line stays hidden.
    function place(root, results, handle) {
      var cards = window.FinderCard;
      var card = cards ? cards.find(root, handle) : null;
      if (!card) return null;

      var slot = document.createElement('div');
      slot.className = 'finder__slot';
      results.appendChild(slot);
      cards.place(slot, card, '');

      var roleEl = card.querySelector('[data-finder-role]');
      if (roleEl) roleEl.hidden = true;

      cards.resolve(card);
      return card;
    }

    // The kit slot. Nothing is built here — a tile that already exists is moved,
    // so the arithmetic on it is the Liquid arithmetic and cannot disagree with
    // the kit's own page.
    function placeKit(root, handle) {
      var slot = root.querySelector('[data-finder-kit]');
      if (!slot) return;

      var tile = root.querySelector('[data-finder-pool] [data-finder-kit-for="' + handle + '"]');
      if (!tile) {
        slot.hidden = true;
        return;
      }

      slot.appendChild(tile);
      slot.hidden = false;
    }

    function setup(root) {
      var config = readJSON(root, '[data-finder-config]');
      if (!config) return;

      var outcomes = config.outcomes || {};
      var strings = config.strings || {};
      var intros = strings.intro || {};

      root.addEventListener('finder:complete', function (event) {
        var answers = event.detail.answers;
        var results = root.querySelector('[data-finder-results]');
        var heading = root.querySelector('[data-finder-result-heading]');
        var intro = root.querySelector('[data-finder-intro]');
        var nomatch = root.querySelector('[data-finder-nomatch]');
        var dogNext = root.querySelector('[data-finder-dog-next]');

        reclaim(root);
        if (dogNext) dogNext.hidden = answers.who !== 'dog';

        // Synchronous: every card is already on the page, so the result is
        // filled before the shell reveals it (finder-shell-head).
        var path = route(answers);
        var placed = [];
        if (path && results) {
          (outcomes[path.id] || []).forEach(function (handle) {
            var card = place(root, results, handle);
            if (card) placed.push(card);
          });
        }

        if (nomatch) nomatch.hidden = placed.length > 0;
        if (heading) {
          heading.textContent = placed.length > 1 ? strings.heading_many : strings.heading_one;
        }
        if (intro) {
          intro.textContent = placed.length && path ? intros[path.id] || '' : '';
          intro.hidden = !intro.textContent;
        }

        var titles = placed.map(function (card) {
          var title = card.querySelector('.finder-card-result__title');
          return title ? title.textContent.trim() : card.dataset.finderCard;
        });

        if (placed.length) {
          var first = placed[0].dataset.finderCard;
          placeKit(root, first);
        }

        // The concierge link carries the answers and the recommendation, so a
        // customer who wants a human does not have to retype any of it.
        var concierge = root.querySelector('[data-finder-concierge]');
        if (concierge && config.email) {
          var given = (path ? path.steps : ['who'])
            .map(function (name) {
              return window.Finder.answerLabel(root, name);
            })
            .filter(Boolean);
          var body = String(strings.concierge_body || '')
            .replace('{titles}', titles.join(', ') || '—')
            .replace('{answers}', given.join(', '));
          concierge.setAttribute('href', window.Finder.mailto(config.email, config.subject, body));
        }
      });
    }

    document.querySelectorAll('[data-finder="footbike"]').forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Escape closes any open header disclosure, and opening one closes the rest.
    // <details> gives us click and keyboard operation for free; this only adds
    // the two behaviours it has no native equivalent for.
    function closeAll(except) {
      document.querySelectorAll('[data-mega-menu][open], [data-header-search][open]').forEach((el) => {
        if (el !== except) el.open = false;
      });
    }

    document.addEventListener('toggle', (event) => {
      const el = event.target;
      if (!(el instanceof HTMLDetailsElement)) return;
      if (!el.hasAttribute('data-mega-menu') && !el.hasAttribute('data-header-search')) return;
      if (el.open) closeAll(el);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('[data-mega-menu][open], [data-header-search][open], [data-mobile-nav][open]');
      if (!open) return;
      open.open = false;
      const summary = open.querySelector('summary');
      if (summary) summary.focus();
    });

    document.addEventListener('pointerdown', (event) => {
      const inside = event.target.closest('[data-mega-menu], [data-header-search]');
      if (!inside) closeAll(null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    // Filters and sort submit on change. Both forms are ordinary GET forms with
    // a real submit button, so this is enhancement — with scripting off the rail
    // still filters and the select still sorts, one click later.
    document.querySelectorAll('[data-filter-form]').forEach(function (form) {
      var actions = form.querySelector('[data-filter-actions]');
      if (actions) actions.hidden = true;

      var timer;
      form.addEventListener('change', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          form.submit();
        }, 250);
      });
    });

    document.querySelectorAll('[data-sort-form]').forEach(function (form) {
      form.addEventListener('change', function () {
        form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Variant picker. (The gallery is `product-gallery`, which follows the
  // `variant:change` event this dispatches on the product root.)
  //
  // The variant picker owns three things and nothing else: which variant id the
  // form posts, which chips are marked unavailable, and the mono measurement line
  // under the size chips. Price, stock and gallery follow from the variant.
  //
  // Everything it needs is already in the DOM. There is no fetch here — the
  // measurement for a size is on that chip's own data attribute, which is what
  // makes the size line zero-click.
  (function () {
    document.querySelectorAll('[data-product]').forEach(function (root) {
      var form = root.querySelector('[data-cart-add]');
      var dataEl = root.querySelector('[data-variant-data]');
      if (!form || !dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return; // Leave the server-rendered default variant in place.
      }

      var idInput = form.querySelector('[data-variant-id]');
      var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-option-input]'));

      function chosen() {
        var values = [];
        inputs.forEach(function (input) {
          if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return values;
      }

      function match(values) {
        return variants.filter(function (variant) {
          return values.every(function (value, index) {
            return value === undefined || variant.options[index] === value;
          });
        });
      }

      // Availability is per-COMBINATION, not per-value: a size can be in stock in
      // one colour and gone in another. Each value is tested against the rest of
      // the current selection rather than against the catalogue as a whole.
      function markAvailability() {
        var current = chosen();
        inputs.forEach(function (input) {
          var index = Number(input.dataset.optionPosition) - 1;
          var probe = current.slice();
          probe[index] = input.value;
          var sellable = match(probe).some(function (variant) {
            return variant.available;
          });
          var chip = input.closest('.option-chips__chip');
          if (chip) chip.dataset.unavailable = String(!sellable);
        });
      }

      function updateMeasurement() {
        var group = root.querySelector('[data-size-chips]');
        if (!group) return;
        var line = group.querySelector('[data-size-measurement]');
        var label = group.querySelector('[data-size-selected]');
        var checked = group.querySelector('[data-option-input]:checked');
        if (!checked) return;
        if (label) label.textContent = checked.value;
        if (line) line.textContent = checked.dataset.measurement || '';
      }

      function updateOptionLabels() {
        root.querySelectorAll('[data-option-group]').forEach(function (group) {
          var checked = group.querySelector('[data-option-input]:checked');
          var label = group.querySelector('[data-option-selected]');
          if (checked && label) label.textContent = checked.value;
        });
      }

      // Re-renders THIS section for the chosen variant and swaps in the two
      // fragments that depend on it. Two things about the Section Rendering API
      // decide the shape of this (docs/CORRECTIONS.md §8):
      //
      //   1. a template section is addressed by its TYPE (`main-product`), not by
      //      its key in the JSON template (`main`) — `?section_id=main` 404s;
      //   2. it renders with SCHEMA DEFAULTS, so every section setting is lost.
      //      That is why the stock location is a THEME setting: it survives, and
      //      the refreshed badge still says "In stock, Perth".
      //
      // Only price and stock are swapped. Everything else on the page is already
      // correct, and the form's variant id is set before this runs — so a failed
      // or slow refresh can never make the cart wrong.
      async function refreshSection(variantId) {
        var type = root.dataset.sectionType;
        if (!type || !window.location.pathname) return;
        var url =
          window.location.pathname +
          '?variant=' + variantId +
          '&section_id=' + encodeURIComponent(type);

        try {
          var response = await fetch(url);
          if (!response.ok) return;
          var markup = new DOMParser().parseFromString(await response.text(), 'text/html');

          ['[data-price]', '[data-stock-line]'].forEach(function (selector) {
            var next = markup.querySelector(selector);
            var current = root.querySelector(selector);
            if (next && current) current.replaceWith(next);
          });

          // The sticky bar is rendered outside `root`, so its price is found on
          // the document. The section render includes it, so the new price comes
          // from the same response.
          var nextSticky = markup.querySelector('[data-sticky-price]');
          var currentSticky = document.querySelector('[data-sticky-price]');
          if (nextSticky && currentSticky) currentSticky.replaceWith(nextSticky);
        } catch (error) {
          // A failed refresh leaves the last good price on screen. The form still
          // posts the right variant id, which is the part that must not be wrong.
        }
      }

      function select() {
        var found = match(chosen())[0];
        markAvailability();
        updateMeasurement();
        updateOptionLabels();
        if (!found) return;

        if (idInput) idInput.value = found.id;
        // The gallery (`product-gallery`) listens for this and scrolls to the
        // variant's photo; the picker does not reach into it.
        root.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: found } }));

        var url = new URL(window.location.href);
        url.searchParams.set('variant', found.id);
        window.history.replaceState({}, '', url);

        refreshSection(found.id);
      }

      inputs.forEach(function (input) {
        input.addEventListener('change', select);
      });

      markAvailability();
      updateMeasurement();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complete-setup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-setup]').forEach(function (form) {
      var rows = Array.prototype.slice.call(form.querySelectorAll('[data-setup-row]'));
      var total = form.querySelector('[data-setup-total]');
      if (!rows.length || !total) return;

      // Formatted from the currency the server printed on the form, never
      // scraped out of a rendered price's text — renaming a class in `price`
      // must not be able to corrupt this total.
      var money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: form.dataset.currency });

      function render() {
        var cents = 0;
        rows.forEach(function (row) {
          var box = row.querySelector('[data-setup-toggle]');
          var quantity = row.querySelector('[data-setup-quantity]');
          var on = box && box.checked;

          // Disabled inputs are not submitted, which is how an unticked row
          // leaves the items[] array without leaving a hole in it.
          if (quantity) quantity.disabled = !on;
          row.dataset.off = String(!on);
          if (on && box) cents += Number(box.dataset.price || 0);
        });

        total.textContent = money.format(cents / 100);
      }

      form.addEventListener('change', function (event) {
        if (event.target.matches('[data-setup-toggle]')) render();
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-measure-guide"] && !Shopify.designMode) return;
  try {
    
  // Opens the measuring guide or the size chart over the page. Every lookup
  // happens at event time: the theme editor re-renders the section on each
  // change, replacing the <dialog>s, so a reference held from page load would
  // go stale.
  (function () {
    var IDS = ['measure-guide', 'size-chart'];

    function dialog(id) {
      return document.getElementById(id);
    }

    function track(node, source) {
      try {
        var api = window[node.dataset.analyticsGlobal];
        if (api && typeof api.event === 'function') {
          api.event(node.dataset.measureEvent, { source: source || '' });
        }
      } catch (error) {
        // Analytics must never be able to break what it only observes.
      }
    }

    function open(id, source) {
      var node = dialog(id);
      if (!node || node.open || typeof node.showModal !== 'function') return false;
      node.showModal();
      track(node, source);
      return true;
    }

    function closeAll() {
      IDS.forEach(function (id) {
        var node = dialog(id);
        if (node && node.open) node.close();
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      var id = link && link.getAttribute('href').slice(1);
      if (id && IDS.indexOf(id) !== -1 && dialog(id)) {
        event.preventDefault();
        open(id, link.dataset.measureSource);
        return;
      }
      var closer = event.target.closest('[data-measure-close]');
      if (closer) {
        closer.closest('dialog').close();
        return;
      }
      // A click on the dialog itself, not its panel, is a click on the backdrop.
      if (event.target.matches && event.target.matches('[data-measure-dialog]')) event.target.close();
    });

    var hash = window.location.hash.slice(1);
    if (IDS.indexOf(hash) !== -1) open(hash, 'hash');

    // The theme editor: selecting the section or one of its blocks opens the
    // measuring popup (or the size chart, where the measuring popup is switched
    // off), so the owner sees what they are editing; a re-render after an edit
    // reopens it; leaving the section closes it.
    function inSection(event) {
      return event.target && event.target.querySelector && event.target.querySelector('[data-measure-dialog]');
    }
    ['shopify:section:select', 'shopify:block:select', 'shopify:section:load'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (inSection(event)) open('measure-guide', 'editor') || open('size-chart', 'editor');
      });
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      if (inSection(event)) closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
